import React, { Fragment } from 'react';
import CardMembership from '../benefits/card-membership';
import DOMPurify from 'isomorphic-dompurify';

const sanitizer = DOMPurify.sanitize;
const serverUrlImages = process.env.REACT_APP_SERVER_URL_IMAGES;
const bgFamily = `${serverUrlImages}/membership/banner_VE.png`;

const MembershipContent = (props) => {
	const {
		formType,
		stepHome = false,
		showText,
		origin,
		contentValue,
		children,
		hash = false,
		if_SOS = false
	} = props;

	return (
		<>
			<div
				className={`md:content pb-16 ${
					formType === 'signing' && origin !== 'sos'
						? 'mt-10 md:mt-12 content'
						: stepHome && stepHome === 'motivo'
						? ' mt-10 md:pt-32 pt-28'
						: formType === 'signing' && origin !== 'sos'
						? 'mt-10'
						: ''
				} ${hash ? 'pt-10' : 'pt-32'}`}
			>
				<div
					className={`w-full flex flex-col-reverse lg:max-w-6xl lg:mx-auto ${
						origin !== 'sos' || stepHome === 'motivo'
							? 'flex-wrap lg:mx-auto md:flex-row'
							: ''
					}`}
				>
					<div
						className={`w-full md:w-1/2 px-10 ${
							origin === 'login' ? 'hidden md:block' : ''
						} ${origin !== 'sos' ? 'md:pl-16 md:pr-4 lg:pr-10 lg:pl-0' : ''} ${
							showText ? 'mx-auto' : 'hidden'
						} `}
					>
						{formType === 'signing' && origin !== 'sos' && (
							<span className="text-pink-500 font-bold text-sm">
								Iniciar sesión
							</span>
						)}
						{origin !== 'sos' || contentValue?.origin !== 'sos' ? (
							<span className="text-5xl text-purple-500 font-bold block leading-tight mb-8">
								<div
									className="font-poppins"
									dangerouslySetInnerHTML={{
										__html: sanitizer(contentValue?.title)
									}}
								/>
							</span>
						) : (
							<div className="text-3xl text-purple-500 font-bold block leading-tight my-auto">
								<div
									className="font-poppins"
									dangerouslySetInnerHTML={{
										__html: sanitizer(contentValue?.title)
									}}
								/>
							</div>
						)}
						<span className="text-2xl text-purple-500 font-bold block leading-tight">
							<div
								className="font-poppins"
								dangerouslySetInnerHTML={{
									__html: sanitizer(contentValue?.afterTitle)
								}}
							/>
						</span>
						<span className="block text-purple-500 text-lg leading-relaxed my-8">
							<div
								dangerouslySetInnerHTML={{
									__html: sanitizer(contentValue?.subtitle)
								}}
							/>
						</span>

						<div className="flex flex-wrap">
							{contentValue?.benefits?.map((benefit) => (
								<Fragment key={benefit.description}>
									{!benefit.button ? (
										<div className="w-full p-3">
											<CardMembership
												img={benefit.icon}
												iconClass={benefit.iconClass}
												title={
													<div
														dangerouslySetInnerHTML={{
															__html: sanitizer(benefit.header)
														}}
													/>
												}
												subtitle={
													<div
														dangerouslySetInnerHTML={{
															__html: sanitizer(benefit.description)
														}}
													/>
												}
											/>
										</div>
									) : (
										<div
											className="hidden md:block md:w-5/12 w-8/17 mr-3"
											dangerouslySetInnerHTML={{
												__html: sanitizer(benefit.button)
											}}
										/>
									)}
								</Fragment>
							))}
						</div>
						{contentValue?.info && (
							<div
								className="my-6 md:mb-0"
								dangerouslySetInnerHTML={{
									__html: sanitizer(contentValue?.info)
								}}
							/>
						)}
					</div>
					<div
						className={`px-10 w-full mb-10 md:mb-0 ${
							stepHome === 'motivo' || origin !== 'sos'
								? 'md:w-1/2 md:mx-auto md:pr-16 md:pl-4 lg:pl-10 lg:pr-0'
								: origin !== 'sos' && stepHome !== 'motivo'
								? ' '
								: 'lg:max-w-3xl md:mx-auto px-20'
						}`}
					>
						{children}
					</div>
				</div>
			</div>
			{if_SOS ? (
				<div className="container mb-16">
					<iframe
						className="max-w-full h-68 sm:h-72 md:h-80"
						autoPlay
						playsInline
						width="1140"
						height="614"
						frameBorder="0"
						allow="autoplay; fullscreen"
						src="https://player.vimeo.com/video/557859405?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
						title="Asistensi S.O.S RD"
					></iframe>
				</div>
			) : (
				<div className="h-64 overflow-hidden flex items-center sm:h-68 md:h-76">
					<img
						src={bgFamily}
						alt="enfermera atendiendo a una persona mayor"
						className="w-full h-auto sm:mt-12 md:mt-20 lg:mt-48"
					/>
				</div>
			)}
		</>
	);
};

export default MembershipContent;
